import { render } from "./FiltersBig.vue?vue&type=template&id=0e8400bc&ts=true"
import script from "./FiltersBig.vue?vue&type=script&lang=ts"
export * from "./FiltersBig.vue?vue&type=script&lang=ts"

import "./FiltersBig.vue?vue&type=style&index=0&id=0e8400bc&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__